import { Button } from "components/commons";
import DeliveryInformationForm from "./delivery-information";
import styles from "./delivery-log.module.scss";
import DeliveryLogProducts from "./products/products";
import WitnessInformation from "./witness-information";
import locale from "localization";
import { useFormContext } from "contexts/form-context";
const DeliveryLogForm = ({ loading, deliveryLog }) => {
  const { isFormSubmittable } = useFormContext();
  return (
    <>
      <div className={styles.form}>
        <DeliveryInformationForm deliveryLog={deliveryLog} />
        <br /> <br />
        <WitnessInformation />
        <br /> <br />
      </div>
      <DeliveryLogProducts />
      <br />
      <br />
      <Button type={"submit"} primary disabled={!isFormSubmittable || loading} loading={loading}>
        {locale.save}
      </Button>
    </>
  );
};

export default DeliveryLogForm;
